<template>
  <Popover :isOpen="isPopoverOpen" :disabled="isPopoverDisabled" @update:isOpen="updatePopoverState">
    <template #trigger>
      <RoundedIcon :src="'/icons/dots.png'"></RoundedIcon>
    </template>
    <ul class="popover-menu">
      <li v-for="(item, index) in menuItems" :key="index" @click.stop="handleItemClick(index)">
        {{ item }}
      </li>
    </ul>
  </Popover>

  <Popup v-if="showDeletePopup" @close="closeDelete">
    <DeleteWorkForm :work="deletingWork" @close="closeDelete" @deleteWork="deleteWorkCompleted" />
  </Popup>
  <Popup v-if="showPopup" @close="closeWork">
    <CreateWorksForm :is-admin="false" :editing="true" v-if="editingWork" :work="editingWork" @close="closeWork" />
    <CreateWorksForm :is-admin="false" v-else @close="closeWork" />
  </Popup>
</template>
<script setup lang="ts">

import RoundedIcon from "~/components/RoundedIcon.vue";
import Popover from "~/components/Popover.vue";
import {useWorkStore} from "~/composables/useWorkStore";
import type {Work} from "~/types/types";
import Popup from "~/components/Popup.vue";
import DeleteWorkForm from "~/components/works/DeleteWorkForm.vue";
import CreateWorksForm from "~/components/works/CreateWorksForm.vue";

const showPopup = ref(false);
const isPopoverDisabled = ref(false);
import {useRouter} from "vue-router";
const router = useRouter();
const isPopoverOpen = ref(false);
const updatePopoverState = (newState: boolean) => {
  isPopoverOpen.value = newState;
};
const emits = defineEmits(['reload']);
const props = defineProps({
  work: {
    type: Object,
    required: true
  }
});
const menuItems = ref(['Edit work', 'Delete work']);

const showDeletePopup = ref(false);
const works = ref<Work[] | any>([]);

const closeWork = async (data: any) => {
  showPopup.value = false;
  editingWork.value = null;
  if (data) {
    works.value = await loadUserWorks();
    emits('reload')
  }
};
const editingWork = ref<Work | any>(null);
const deletingWork = ref<Work | any>(null);
const editWork = async (data: any) => {
  editingWork.value = data;
  showPopup.value = true;
  console.log('editWork', editingWork.value);
};

const deleteWorkFunction = async (data: any) => {
  console.log('deleteWork');
  deletingWork.value = data;
  showDeletePopup.value = true;
};
const closeDelete = async () => {
  showDeletePopup.value = false
  deletingWork.value = null;
  console.log('close')
};


const { galleries, patchGallery, loadUserWorks, createGallery, deleteGallery, loadUserGalleries, deleteWork, loadVisitingUserGalleries } = useWorkStore();

const saveGallery = async (gallery: any) => {
  const save = await patchGallery(gallery, gallery._id);
  console.log('saved', save);
  emits('reload');
};
const refresh = ref(false);

const deleteWorkCompleted = async (data: any) => {
  console.log('deleteWork');
  await deleteWork(deletingWork.value._id);
  showDeletePopup.value = false;
  deletingWork.value = null;
  refresh.value = true;
  router.push('/talent/profile')
};
const handleItemClick = (index: any) => {
  console.log('Clicked item:', index);
  switch (index) {
    case 0:
      editWork(props.work);
      break;
    case 1:
      deleteWorkFunction(props.work);
      break;
    default:
      break;
  }
};
onMounted(() => {
  console.log('work functions init');
})
</script>